import { deiterateAPI } from '@/js/external-js/variableModules/utils/deiterateAPI.util';

const COMPANY_API = '/v1/company';

const knownCategories = [
    "billing",
    "billingDetails",
    "complianceModules",
    "features",
    "general",
    "integrations",
    "menus",
    "productOverview"
]

export const getCompanySettings = async (companyID: string = window.companyID, category: string = 'all') => { 
    if (!companyID) {
        throw new Error('Company ID is required');
    }

    if (!category || !knownCategories.includes(category) && category !== 'all') {
        throw new Error('Invalid category');
    }

    try {
        const endpoint = category === 'all' 
            ? `${COMPANY_API}/settings`
            : `${COMPANY_API}/settings/${category}`;
        
        const res = await deiterateAPI.GET(endpoint, {
            mode: 'cors',
            backend: 'thalassa',
            headers: { 'X-Tenancy-Id': companyID, 'Company-ID': companyID }
        });

        return res.data || {};
    } catch (error) {
        console.error('Error fetching company settings:', error);
        throw error;
    }
};

export const saveCompanySettings = async (companyID: string = window.companyID, category: string, data: any) => { 
    if (!companyID) {
        throw new Error('Company ID is required');
    }

    if (!category || !knownCategories.includes(category) || category === 'all') {
        throw new Error('Invalid category');
    }

    try {
        await deiterateAPI.PUT(`${COMPANY_API}/settings/${category}`, {
            mode: 'cors',
            backend: 'thalassa',
            headers: { 'X-Tenancy-Id': companyID, 'Company-ID': companyID },
            body: JSON.stringify(data)
        });
    } catch (error) {
        console.error('Error saving company settings:', error);
        throw error;
    }
}

export const getCompanyInfo = async (companyID: string = window.companyID) => {
    if (!companyID) {
        throw new Error('Company ID is required');
    }

    try {
        const res = await deiterateAPI.GET(`${COMPANY_API}/info`, {
            mode: 'cors',
            backend: 'thalassa',
            headers: { 'X-Tenancy-Id': companyID, 'Company-ID': companyID }
        });

        return res.data || {};
    } catch (error) {
        console.error('Error fetching company info:', error);
        throw error;
    }
}

interface UpdateOperation {
    [key: string]: any | null;
    $merge?: boolean;
};

interface UpdateOperations {
    set?: UpdateOperation & {
        $merge?: boolean;
    };
    update?: UpdateOperation;
    arrayUnion?: UpdateOperation;
    arrayRemove?: UpdateOperation;
    merge?: boolean;
};

/**
 * Saves company information with support for nested field updates via Thalassa API
 * @param companyId - The ID of the company
 * @param operations - Operations to perform (set, update, arrayUnion, arrayRemove)
 */
export const saveCompanyInfo = async (
  companyId: string, 
  operations: UpdateOperations & { merge?: boolean } = { merge: true }
) => { 
    if (!companyId) {
        throw new Error('Company ID is required');
    }

    console.log('Saving company info for ID:', companyId, 'with operations:', operations);

    try {
        await deiterateAPI.PUT(`${COMPANY_API}/info`, {
            mode: 'cors',
            backend: 'thalassa',
            headers: { 'X-Tenancy-Id': companyId, 'Company-ID': companyId },
            body: JSON.stringify(operations)
        });
        
        return true;
    } catch (error) {
        console.error('Error saving company info:', error);
        throw error;
    }
}

export default {
    getCompanySettings,
    getCompanyInfo,
    saveCompanySettings,
    saveCompanyInfo
}